import { render, staticRenderFns } from "./SdkSmallInformation.vue?vue&type=template&id=24fa0ab6&"
import script from "./SdkSmallInformation.vue?vue&type=script&lang=js&"
export * from "./SdkSmallInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24fa0ab6')) {
      api.createRecord('24fa0ab6', component.options)
    } else {
      api.reload('24fa0ab6', component.options)
    }
    module.hot.accept("./SdkSmallInformation.vue?vue&type=template&id=24fa0ab6&", function () {
      api.rerender('24fa0ab6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Input/SDK/SdkSmallInformation.vue"
export default component.exports